// LYVA — main JS

// Scroll reveal
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("visible"); });
}, { threshold: 0.1 });
document.querySelectorAll(".k-reveal").forEach(el => observer.observe(el));

// Header scroll state
const header = document.querySelector(".k-header");
if (header) {
  window.addEventListener("scroll", () => {
    header.classList.toggle("scrolled", window.scrollY > 40);
  }, { passive: true });
}

// Mobile menu
const burger = document.querySelector(".k-burger");
const mobileMenu = document.querySelector(".k-mobile-menu");
const menuClose = document.querySelector(".k-mobile-menu__close");
if (burger && mobileMenu) {
  burger.addEventListener("click", () => mobileMenu.classList.add("open"));
  menuClose && menuClose.addEventListener("click", () => mobileMenu.classList.remove("open"));
}

// Waitlist Klaviyo submit
var _klSelProds = [];

function lyvaToggleProd(p, el) {
  if (_klSelProds.includes(p)) {
    _klSelProds = _klSelProds.filter(x => x !== p);
    el.classList.remove("sel");
  } else {
    _klSelProds.push(p);
    el.classList.add("sel");
  }
}

async function lyvaJoin() {
  var emailEl = document.getElementById("kl-email");
  var btn = document.getElementById("kl-btn");
  if (!emailEl || !btn) return;
  var email = emailEl.value.trim().toLowerCase();
  if (!email || !email.includes("@")) { emailEl.focus(); return; }
  btn.textContent = "Sending…";
  btn.disabled = true;
  try {
    var res = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=Yi5bjY", {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": "2023-12-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            list_id: "WZTzUe",
            email_marketing: { consent: "SUBSCRIBED" },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  properties: {
                    product_interest: _klSelProds.length ? _klSelProds.join(", ") : "Not specified",
                    source: "shopify store"
                  }
                }
              }
            }
          }
        }
      })
    });
    if (res.ok || res.status === 202) {
      var wrap = document.getElementById("kl-form-wrap");
      var success = document.getElementById("kl-success");
      if (wrap) wrap.style.display = "none";
      if (success) success.style.display = "block";
    } else {
      btn.textContent = "Join waitlist";
      btn.disabled = false;
    }
  } catch (e) {
    btn.textContent = "Join waitlist";
    btn.disabled = false;
  }
}

var klEmailInput = document.getElementById("kl-email");
if (klEmailInput) {
  klEmailInput.addEventListener("keydown", function(e) {
    if (e.key === "Enter") lyvaJoin();
  });
}

// Add to cart
async function lyvaAddToCart(variantId, qty) {
  qty = qty || 1;
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    window.location.href = "/cart";
  } catch(e) {
    console.error("Add to cart failed", e);
  }
}
